import { useLocation, useParams, type Location } from 'react-router';
import { motion } from 'motion/react';
import { useMemo } from 'react';
import { createRunStore } from '@inference.engine/agentic-react';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import type { SendMessageInput } from '@/features/chats';
import { testSessionRun } from '@/features/agent-builder/model/test-sessions';
import { eases } from '@/shared/constants/motion.constants';
import { ChatSession } from './ChatSession';

const StreamChatSessionInternal = (props: { chatId: string; workspaceId: string }) => {
  const runStore = useMemo(createRunStore, [props.chatId]);
  const { state: locationState } = useLocation() as Location<
    | {
        agentId: string;
        args: SendMessageInput;
      }
    | undefined
  >;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, ease: eases.quartOut }}
      style={{ height: '100%' }}
    >
      <ChatSession
        chatId={props.chatId}
        workspaceId={props.workspaceId}
        runStore={runStore}
        // A conversation continued from the builder keeps running the draft.
        runOptions={(contextId) => {
          const test = testSessionRun(contextId);
          return test ? { ...test } : undefined;
        }}
        {...(locationState?.args ? { initialMessage: locationState.args } : {})}
      />
    </motion.div>
  );
};

export const StreamChatSession = () => {
  const selectedWorkspaceId = useCurrentWorkspaceId();
  const { chatId } = useParams<{ chatId: string }>();

  if (!selectedWorkspaceId || !chatId) {
    return null;
  }

  // Uses global chat store via useChatStore
  return <StreamChatSessionInternal chatId={chatId} workspaceId={selectedWorkspaceId} />;
};
